import React, { FunctionComponent, PropsWithChildren } from 'react';
import { BaseLayout } from '../../Component/BaseLayout/BaseLayout';

import './AccessoriesPage.scss';
import '../../Component/Sidebar/Sidebar.scss';
import '../../Component/SelectionMarker/SelectionMarker.scss';

interface AccessoriesPageProps {
    className?: string;
}

export const AccessoriesPage: FunctionComponent<PropsWithChildren<AccessoriesPageProps>> = (props) => {
    return (
        <BaseLayout>
            <div className={['shopping-planner-accessories-page', props.className ?? ''].join(' ')}>
                {props.children}
            </div>
        </BaseLayout>
    );
};
